/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Misc_Posts_PriceInputs */

const id_misc_posts_price = /** @type {(inputs: Misc_Posts_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`$49.99`)
};

const ms_misc_posts_price = /** @type {(inputs: Misc_Posts_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`$49.99`)
};

const da_misc_posts_price = /** @type {(inputs: Misc_Posts_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`$49.99`)
};

const de_misc_posts_price = /** @type {(inputs: Misc_Posts_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`$49.99`)
};

const en_us2_misc_posts_price = /** @type {(inputs: Misc_Posts_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`$49.99`)
};

const es_es2_misc_posts_price = /** @type {(inputs: Misc_Posts_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`$49.99`)
};

const es_mx2_misc_posts_price = /** @type {(inputs: Misc_Posts_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`$49.99`)
};

const fil_misc_posts_price = /** @type {(inputs: Misc_Posts_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`$49.99`)
};

const fr_misc_posts_price = /** @type {(inputs: Misc_Posts_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`$49.99`)
};

const it_misc_posts_price = /** @type {(inputs: Misc_Posts_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`$49.99`)
};

const hu_misc_posts_price = /** @type {(inputs: Misc_Posts_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`$49.99`)
};

const nl_misc_posts_price = /** @type {(inputs: Misc_Posts_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`$49.99`)
};

const no_misc_posts_price = /** @type {(inputs: Misc_Posts_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`$49.99`)
};

const pl_misc_posts_price = /** @type {(inputs: Misc_Posts_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`$49.99`)
};

const pt_br2_misc_posts_price = /** @type {(inputs: Misc_Posts_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`US$ 49,99`)
};

const pt_misc_posts_price = /** @type {(inputs: Misc_Posts_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`$49.99`)
};

const ro_misc_posts_price = /** @type {(inputs: Misc_Posts_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`$49.99`)
};

const fi_misc_posts_price = /** @type {(inputs: Misc_Posts_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`$49.99`)
};

const sv_misc_posts_price = /** @type {(inputs: Misc_Posts_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`$49.99`)
};

const vi_misc_posts_price = /** @type {(inputs: Misc_Posts_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`$49.99`)
};

const tr_misc_posts_price = /** @type {(inputs: Misc_Posts_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`$49.99`)
};

const cs_misc_posts_price = /** @type {(inputs: Misc_Posts_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`$49.99`)
};

const bg_misc_posts_price = /** @type {(inputs: Misc_Posts_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`$49.99`)
};

const ru_misc_posts_price = /** @type {(inputs: Misc_Posts_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`$49.99`)
};

const uk_misc_posts_price = /** @type {(inputs: Misc_Posts_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`$49.99`)
};

const ar_misc_posts_price = /** @type {(inputs: Misc_Posts_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`$49.99`)
};

const hi_misc_posts_price = /** @type {(inputs: Misc_Posts_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`$49.99`)
};

const th_misc_posts_price = /** @type {(inputs: Misc_Posts_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`$49.99`)
};

const ja_misc_posts_price = /** @type {(inputs: Misc_Posts_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`$49.99`)
};

const zh_cn2_misc_posts_price = /** @type {(inputs: Misc_Posts_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`$49.99`)
};

const zh_hant1_misc_posts_price = /** @type {(inputs: Misc_Posts_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`$49.99`)
};

const ko_misc_posts_price = /** @type {(inputs: Misc_Posts_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`$49.99`)
};

/**
* | output |
* | --- |
* | "$49.99" |
*
* @param {Misc_Posts_PriceInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const misc_posts_price = /** @type {((inputs?: Misc_Posts_PriceInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Misc_Posts_PriceInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_misc_posts_price(inputs)
	if (locale === "ms") return ms_misc_posts_price(inputs)
	if (locale === "da") return da_misc_posts_price(inputs)
	if (locale === "de") return de_misc_posts_price(inputs)
	if (locale === "en-US") return en_us2_misc_posts_price(inputs)
	if (locale === "es-ES") return es_es2_misc_posts_price(inputs)
	if (locale === "es-MX") return es_mx2_misc_posts_price(inputs)
	if (locale === "fil") return fil_misc_posts_price(inputs)
	if (locale === "fr") return fr_misc_posts_price(inputs)
	if (locale === "it") return it_misc_posts_price(inputs)
	if (locale === "hu") return hu_misc_posts_price(inputs)
	if (locale === "nl") return nl_misc_posts_price(inputs)
	if (locale === "no") return no_misc_posts_price(inputs)
	if (locale === "pl") return pl_misc_posts_price(inputs)
	if (locale === "pt-BR") return pt_br2_misc_posts_price(inputs)
	if (locale === "pt") return pt_misc_posts_price(inputs)
	if (locale === "ro") return ro_misc_posts_price(inputs)
	if (locale === "fi") return fi_misc_posts_price(inputs)
	if (locale === "sv") return sv_misc_posts_price(inputs)
	if (locale === "vi") return vi_misc_posts_price(inputs)
	if (locale === "tr") return tr_misc_posts_price(inputs)
	if (locale === "cs") return cs_misc_posts_price(inputs)
	if (locale === "bg") return bg_misc_posts_price(inputs)
	if (locale === "ru") return ru_misc_posts_price(inputs)
	if (locale === "uk") return uk_misc_posts_price(inputs)
	if (locale === "ar") return ar_misc_posts_price(inputs)
	if (locale === "hi") return hi_misc_posts_price(inputs)
	if (locale === "th") return th_misc_posts_price(inputs)
	if (locale === "ja") return ja_misc_posts_price(inputs)
	if (locale === "zh-CN") return zh_cn2_misc_posts_price(inputs)
	if (locale === "zh-Hant") return zh_hant1_misc_posts_price(inputs)
	return ko_misc_posts_price(inputs)
});
export { misc_posts_price as "misc.posts.price" }